var $183cacea4b9be557$exports = {};
$183cacea4b9be557$exports = {
    "close": `Fechar`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} notifica\xe7\xe3o`,
            other: ()=>`${formatter.number(args.count)} notifica\xe7\xf5es`
        })}.`
};


export {$183cacea4b9be557$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
